import { styled } from "@mui/material/styles";

export const FormItemWrap = styled("div")(({ theme }) => ({
  width: "100%",
  display: "block",
  marginBottom: 16,
  "& .top-wrap": {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
  },
  "& label": {
    fontSize: 14,
    fontWeight: "normal",
    lineHeight: "normal",
    color: theme.palette.common.black,
    paddingBottom: 10,
  },
  "& .optional": {
    fontSize: 12,
    letterSpacing: "-0.4px",
    textAlign: "right",
    color: theme.palette.text.secondary,
  },
  "& .form-item": {
    width: "100% !important",
  },
}));
